import React, { Component, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import Slider from "react-slick";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/bundle";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import "../Styles/Home.css";
import { Link } from "react-router-dom";
import api from "../api";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0.29)",
        height: "auto",
        padding: "3px",
        width: "26px",
        borderRadius: "10px 50px 50px 10px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0.29)",
        height: "auto",
        padding: "3px",
        width: "26px",
        borderRadius: "50px 10px 10px 50px",
      }}
      onClick={onClick}
    />
  );
}

const settings = {
    autoplay: true,
  autoplaySpeed: 5000,
    infinite: true,
  speed: 800,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: true,
  // variableWidth: true, 
 
  responsive: [
    {
      breakpoint: 1030,
      settings: {
        slidesToShow: 5,
      },
    },
   
   
    {
      breakpoint: 870,
      settings: {
        slidesToShow: 4,
      },
    },

    {
      breakpoint: 580,
      settings: {
        slidesToShow: 3,
      },
    },
     {
       breakpoint: 420,
       settings: {
         slidesToShow: 2.5,
       },
     },
  ],
};

function ProductBox({ url }) {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const [laptops, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addingToCart, setAddingToCart] = useState("0");
  const[isMobile,setIsMobile]=useState(window.innerWidth <= 730)

useEffect(() => {
  if (laptops.length > 0) {
    setLoading(false);
  }
}, [laptops]);

  useEffect(() => {
    getProductList();
  }, []);
  const getProductList = async () => {
    try {
      const response = await api.get(url);

      console.log("Products: srdf", response.data.product_list);
      setProductList(response.data.product_list);
    } catch (error) {
      console.log("Error fetching products:", error);
    }
  };

  const addWishlist = async (id) => {
    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      const response = await api.post(`/user_api/add-wishlist`, {
        access_token: JSON.parse(accessToken),
        product_id: id,
      });
      console.log(response.data);

      getProductList();
    } catch (error) {
      console.log("Error saving wishlist:", error);
    }
  };

  const handlePress = async (url, clicked,id) => {
    console.log("uyghtgh", clicked);

    if (!accessToken) {
      navigate("/login");
      return;
    }

    setAddingToCart(id);

    try {
      if (!clicked) {
        navigate("/cart");
      } else {
        const response = await api.post(`/user_api/cart/add-to-cart-web-home`, {
          access_token: JSON.parse(accessToken),
          product_url: url,
          qty: 1,
        });
        console.log("jyghjgjgjh", response.data);
        if (response.data.status === "success") {
          getProductList();
        } else {
          console.log("something fisshy");
        }
      }
    } catch (error) {
      console.log("Error adding cart:", error);
    } finally {
      setAddingToCart("0");
    }
  };

  return (
    <div className="products-grid" style={{overflowY:"hidden"}}>
    
<Slider {...settings}>
  {loading
    ? Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="product-card1" style={{ flexDirection: 'column', height: 'auto' }}>
          <div className="discount-badge pulse-animation">
            <Skeleton width={60} height={20} />
          </div>

          <div
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              zIndex: 999,
            }}
          >
            <Skeleton circle width={20} height={20} />
          </div>

          <div className="product-image-container">
            <Skeleton height={150} width="100%" />
          </div>

          <div className="product-info1" style={{ padding: "0px" }}>
            <h4 className="product-name" style={{ marginTop: "0px" }}>
              <Skeleton width={`80%`} height={20} />
            </h4>

            <div className="price-container">
              <Skeleton width={60} height={15} />
              <Skeleton width={60} height={15} />
            </div>

            <Skeleton height={35} width={120} style={{ marginTop: 10 }} />
          </div>
        </div>
      ))
    : laptops.slice(0, 20).map((product) => (
        <div
          key={product.id}
          onClick={() => navigate(`/Product_details_final/${product.product_url}`)}
          className="product-card-item"
          
        >
          {product.discout ===0?" ":
          <div className="discount-badge pulse-animation">
            {product.discout}% OFF
          </div>
          }

          <div
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              zIndex: 999,
            }}
            onClick={(e) => {
              e.stopPropagation();
              addWishlist(product.id);
            }}
          >
            <FaHeart
              style={{
                color: product.wish_button === "checked" ? "red" : "gray",
                fontSize: "20px",
                transition: "color 0.3s",
              }}
            />
          </div>


          <div className="product-image-wrapper">
            <img
              src={product.product_image_path}
              alt={product.product_name}
              className="product-card-image hover-zoom"
              loading="lazy"
            />
          </div>

          <div className="product-info1" style={{ padding: "0px" }}>
            <div className="product-name" style={{ marginTop: "0px" }}>
              {isMobile?`${product.product_name.substring(0, 20)}...`:
              product.product_name.length > 30
                ? `${product.product_name.substring(0, 30)}...`
                : product.product_name}
            </div>
 
            <div className="product-pricing" style={{display: "flex", justifyContent: "space-between", alignItems: "center",gap:"10px"}}>
              <span className="selling-price">AED{product.selling_price}</span>
              <span className="original-price">AED{product.initial_cost}</span>
            </div>

            <button
              className="add-to-cart-btn"
              onClick={(e) => {
                e.stopPropagation();
                handlePress(product.product_url, product.add_to_cart,product.id);
              }}
            >
              <i className="fas fa-shopping-cart"></i>
              <span>{product.add_to_cart ?addingToCart===product.id?"ADDING..": "ADD TO CART" : "GO TO CART"}</span>
            </button>
          </div>
        </div>
      ))}
</Slider>

    </div>
  );
}

export default ProductBox;
